/*eslint no-use-before-define:0 *///TODO REMOVE THIS
const dd = require('ES/lib/dd');
const _ = require('ES/lib/lodash');
const radio = require('ES/lib/radio');
const Modal = require('ES/widgets/Modal');
const esUtils = require('ES/utils/esUtils');
const FormMixin = require('ES/widgets/forms/FormMixin');
const RadioMixin = require('ES/utils/RadioMixin');
const ErrorAlert = require('ES/widgets/ErrorAlert');
const LoadingWrap = require('ES/widgets/LoadingWrap');
const VerticalScroll = require('ES/widgets/VerticalScroll');
const HorizontalFields = require('ES/widgets/HorizontalFields');

let service_name_map = {
  infusionsoft: 'Keap Opportunities',
  zoho: 'Zoho CRM Opportunities'
};

module.exports = dd.createClass({
  getInitialState: function () {
    return {loading: false, error_msg: null};
  },
  render: function () {
    const Displaylists = this.props.Displaylists;
    const link_to_event = _.get(this.props, "link_to_event", null);
    const service = _.has(service_name_map, this.props.service_to_import_from) ? this.props.service_to_import_from : _.first(_.keys(service_name_map));
    const service_name = service_name_map[service];
    let grabber = null;
    switch (service) {
      case "infusionsoft":
        grabber = InfusionsoftGrabber({Displaylists, link_to_event});
        break;
      case "zoho":
        grabber = ZohoGrabber({
          Displaylists,
          link_to_event,
          get_opportunities: 'Thirdpartyconnection_Zoho_get_opportunities'
        });
        break;
      default:
    }

    return VerticalScroll(null,
      dd.div({className: 'ImportEvent panel panel-default', style: {margin: 10}},
        dd.div({className: 'panel-body'},
          ErrorAlert({message: this.state.error_msg}),
          LoadingWrap({is_loading: this.state.loading || _.isEmpty(Displaylists)},
            _.isEmpty(link_to_event) ? dd.h3(null, 'Import ', service_name) : null,
            dd.div({className: 'alert alert-info'},
              _.isEmpty(link_to_event) ? dd.div(null,
                'eSpeakers and ', service_name, ' work together like Sonny and Cher.'
              ) : 'Link an existing Zoho Opportunity to this event.',
              _.isEmpty(link_to_event) ? ('This screen helps you locate one of your ' + service_name + ' to bring into eSpeakers as an event.') : null
            ),
            grabber
          )
        )
      )
    );
  }
});

let ZohoGrabber = dd.createClass({
  mixins: [FormMixin, RadioMixin],
  getInitialState: function () {
    return {stagetimes: null, loading: false, error_msg: null};
  },
  componentWillMount: function () {

  },
  buildFields() {
    const Displaylists = this.props.Displaylists;
    let schema = {
      speaker: {
        label: 'speaker',
        type: 'select',
        placeholder: '-- select a speaker --',
        options: _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
          return [spkr.sid, spkr.name_full];
        }))
      },
      searchfor: {
        label: 'find opportunity',
        type: 'text',
        placeholder: '[search keyword]',
      }
    };

    return schema;
  },
  onFormChanged(field_path, new_value) {
    switch (field_path) {
      case "speaker":
        //this._form_onChange('searchfor', null);//clear it when speaker changes
        break;
      case "searchfor":
        //radio(self.props.get_opportunities).broadcast(this.state.data.speaker, new_value);
        break;
      default:
    }
  },

  onSubmitSearch: esUtils.wrapPreventDefault(function () {
    if (!_.isEmpty(this.state.data.speaker) && !_.isEmpty(this.state.data.searchfor)) {
      radio(this.props.get_opportunities).broadcast(this.state.data.speaker, this.state.data.searchfor);
    }
  }),

  render: function () {
    let data = this.state.data || {};
    let fields = this.buildFields();
    let errors = this.state.errors || {};
    let Displaylists = this.props.Displaylists;
    const link_to_event = _.get(this.props, "link_to_event");

    return dd.div(null,
      dd.form({className: 'form-horizontal', onSubmit: this.onSubmitSearch},
        ErrorAlert({message: this.state.error_msg}),
        HorizontalFields({
          fields: fields,
          errors: errors,
          buildInput: this._form_buildInput,
          FormButtons: {submit_btn_text: 'search'}
        }),
        (_.isEmpty(_.get(this.state, "data.speaker")) || _.isEmpty(_.get(this.state, "data.searchfor"))) ? null : HorizontalFields.FormButtons({submit_btn_text: 'Search'}),
        LoadingWrap({is_loading: this.state.loading})
      ),
      ZohoOpportunitiesList({
        radio_get_opportunities: 'Thirdpartyconnection_Zoho_get_opportunities',
        radio_opportunities: 'Thirdpartyconnection_Zoho_opportunities',
        radio_get_opportunities_failed: 'Thirdpartyconnection_Zoho_get_opportunities_failed',
        service: 'zoho',
        link_to_event,
        Displaylists: Displaylists,
        speaker_id: data.speaker,
        searchfor: data.searchfor,
      })
    );
  }
});

let InfusionsoftGrabber = dd.createClass({
  mixins: [FormMixin, RadioMixin],
  getInitialState: function () {
    return {stagetimes: null, loading: false, error_msg: null};
  },
  componentWillMount: function () {
    let self = this;
    self.radio = {
      Thirdpartyconnection_Infusionsoft_get_stagetimes: function (sid) {
        if (sid === self.state.data.speaker) {
          self.setState({stagetimes: null, loading: true, error_msg: null});
        }
      },
      Thirdpartyconnection_Infusionsoft_stagetimes: function (sid, stagetimes) {
        if (sid === self.state.data.speaker) {
          self.setState({stagetimes: stagetimes, loading: false, error_msg: null});
        }
      },
      Thirdpartyconnection_Infusionsoft_get_stagetimes_failed: function (sid, message) {
        if (sid === self.state.data.speaker) {
          self.setState({stagetimes: null, loading: false, error_msg: 'Failed to grab stagetimes: ' + message});
        }
      }
    };
  },
  buildFields: function () {
    let Displaylists = this.props.Displaylists;
    let schema = {
      speaker: {
        label: 'speaker',
        type: 'select',
        placeholder: '-- select a speaker --',
        options: _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
          return [spkr.sid, spkr.name_full];
        }))
      }
    };
    if (!_.isEmpty(this.state.stagetimes)) {
      schema.stagetime = {
        label: 'opportunities in',
        type: 'select',
        placeholder: '-- select stage --',
        options: _.object(_.map(this.state.stagetimes, function (s) {
          return [s.Id, s.StageName];
        }))
      };
    }
    return schema;
  },
  onFormChanged: function (field_path, new_value) {
    if (field_path === 'speaker') {
      if (new_value !== null && new_value > 0) {
        radio('Thirdpartyconnection_Infusionsoft_get_stagetimes').broadcast(new_value);
      }
      this._form_onChange('stagetime', null);//clear it when speaker changes
    } else {
      if (new_value !== null && new_value > 0) {
        radio('Thirdpartyconnection_Infusionsoft_get_opportunities').broadcast(this.state.data.speaker, new_value);
      }
    }
  },
  render() {
    let data = this.state.data || {};
    let fields = this.buildFields();
    let errors = this.state.errors || {};
    let Displaylists = this.props.Displaylists;
    const link_to_event = _.get(this.props, "link_to_event");

    return dd.div(null,
      dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
        ErrorAlert({message: this.state.error_msg}),
        HorizontalFields({
          fields: fields,
          errors: errors,
          buildInput: this._form_buildInput
        }),
        LoadingWrap({is_loading: this.state.loading})
      ),
      OpportunitiesList({
        Displaylists: Displaylists,
        speaker_id: data.speaker,
        stagetime_id: data.stagetime,
        link_to_event,
        stagetime_name: (fields.stagetime && fields.stagetime.options[data.stagetime]) || null
      })
    );
  }
});

let ZohoOpportunitiesList = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {opp_key: this.__opportunityKey(this.props), opportunities: null, loading: false, error_msg: null, selected_opportunity: null};
  },
  componentWillReceiveProps: function (props) {
    if (this.state.opp_key !== this.__opportunityKey(props)) {
      this.setState({opportunities: null, loading: null, error_msg: null});
    }
  },
  __opportunityKey: function (props) {
    return props.speaker_id + '_' + props.searchfor;
  },
  componentWillMount: function () {
    const self = this;
    self.radio = {
      [self.props.radio_get_opportunities]: function (sid, searchfor) {
        if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
          self.setState({opportunities: null, loading: true, error_msg: null});
        }
      },
      [self.props.radio_opportunities]: function (sid, searchfor, opportunities) {
        if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
          self.setState({opportunities: opportunities, loading: false, error_msg: null});
        }
      },
      [self.props.radio_get_opportunities_failed]: function (sid, searchfor, message) {
        if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
          self.setState({opportunities: null, loading: false, error_msg: 'Failed to grab opportunities: ' + message});
        }
      }
    };
  },
  __setSelectedOpportunity: function (opp) {
    let self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({selected_opportunity: opp});
    });
  },
  render: function () {
    const speaker_id = this.props.speaker_id;
    const Displaylists = this.props.Displaylists;
    const opportunities = this.state.opportunities;
    const link_to_event = _.get(this.props, "link_to_event");

    return dd.div(null,
      ErrorAlert({message: this.state.error_msg}),
      LoadingWrap({is_loading: this.state.loading},
        ( _.isArray(opportunities) && (opportunities.length > 0)) ? dd.p({style:{marginTop:"1rem"}}, "Select an Opportunity from the list") : null,
        _.isArray(opportunities) ? (opportunities.length > 0 ? dd.table({className: 'table table-hover'},
          dd.thead(null,
            dd.tr(null,
              dd.th(null, 'close date'),
              dd.th(null, 'client'),
              dd.th(null, 'description')
            )
          ),
          dd.tbody(null,
            _.map(opportunities, function (opportunity, i) {
              return dd.tr({key: i, className: 'clickable', onClick: this.__setSelectedOpportunity(opportunity)},
                dd.td(null, opportunity.date),
                dd.td(null, opportunity.ProspectName),
                dd.td(null, '"', opportunity.OpportunityTitle, '"')
              );
            }, this)
          )
        ) : dd.div({className: 'text-center'},
          dd.b(null, 'no opportunities '), ' matching ', _.get(this.props, "searchfor")
        )) : null
      ),
      this.state.selected_opportunity === null ? null : OpportunityGrabber({
        Displaylists: Displaylists,
        opportunity: this.state.selected_opportunity,
        speaker_id: speaker_id,
        onClose: this.__setSelectedOpportunity(null),
        service: "zoho",
        link_to_event,
        radio_import_opportunities: (_.isEmpty(link_to_event)) ? "Thirdpartyconnection_Zoho_import_opportunities" : "Thirdpartyconnection_Zoho_link_opportunities",
        radio_import_opportunities_failed: "Thirdpartyconnection_Zoho_import_opportunities_failed",
        radio_import_opportunities_succeeded: "Thirdpartyconnection_Zoho_import_opportunities_succeeded"
      }),
      dd.br(),
      dd.br()
    );
  }
});


let OpportunitiesList = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {opp_key: this.__opportunityKey(this.props), opportunities: null, loading: false, error_msg: null, selected_opportunity: null};
  },
  componentWillReceiveProps: function (props) {
    if (this.state.opp_key !== this.__opportunityKey(props)) {
      this.setState({opportunities: null, loading: null, error_msg: null});
    }
  },
  __opportunityKey: function (props) {
    return props.speaker_id + '_' + props.stagetime_id;
  },
  componentWillMount: function () {
    const self = this;
    self.radio = {
      Thirdpartyconnection_Infusionsoft_get_opportunities: function (sid, stagetime_id) {
        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
          self.setState({opportunities: null, loading: true, error_msg: null});
        }
      },
      Thirdpartyconnection_Infusionsoft_opportunities: function (sid, stagetime_id, opportunities) {
        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
          self.setState({opportunities: opportunities, loading: false, error_msg: null});
        }
      },
      Thirdpartyconnection_Infusionsoft_get_opportunities_failed: function (sid, stagetime_id, message) {
        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
          self.setState({opportunities: null, loading: false, error_msg: 'Failed to grab stagetimes: ' + message});
        }
      }
    };
  },
  __setSelectedOpportunity: function (opp) {
    var self = this;
    return esUtils.wrapPreventDefault(function () {
      self.setState({selected_opportunity: opp});
    });
  },
  render: function () {
    const speaker_id = this.props.speaker_id;
    const Displaylists = this.props.Displaylists;
    const opportunities = this.state.opportunities;
    const link_to_event = _.get(this.props, "link_to_event");

    return dd.div(null,
      ErrorAlert({message: this.state.error_msg}),
      LoadingWrap({is_loading: this.state.loading},
        _.isArray(opportunities) ? (opportunities.length > 0 ? dd.table({className: 'table table-hover'},
          dd.thead(null,
            dd.tr(null,
              dd.th(null, 'close date'),
              dd.th(null, 'client'),
              dd.th(null, 'description')
            )
          ),
          dd.tbody(null,
            _.map(opportunities, function (opportunity, i) {
              return dd.tr({key: i, className: 'clickable', onClick: this.__setSelectedOpportunity(opportunity)},
                dd.td(null, opportunity.date),
                dd.td(null, opportunity.ProspectName),
                dd.td(null, '"', opportunity.OpportunityTitle, '"')
              );
            }, this)
          )
        ) : dd.div({className: 'text-center'},
          dd.b(null, 'no opportunities '), ' in ', this.props.stagetime_name
        )) : null
      ),
      this.state.selected_opportunity === null ? null : OpportunityGrabber({
        Displaylists: Displaylists,
        opportunity: this.state.selected_opportunity,
        speaker_id: speaker_id,
        onClose: this.__setSelectedOpportunity(null),
        service: "infusionsoft",
        link_to_event,
        radio_import_opportunities: (_.isEmpty(link_to_event)) ? "Thirdpartyconnection_Infusionsoft_import_opportunities" : "Thirdpartyconnection_Infusionsoft_import_opportunities",
        radio_import_opportunities_failed: "Thirdpartyconnection_Infusionsoft_import_opportunities_failed",
        radio_import_opportunities_succeeded: "Thirdpartyconnection_Infusionsoft_import_opportunities_succeeded"
      }),
      dd.br(),
      dd.br()
    );
  }
});

let OpportunityGrabber = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {event_status: 0, importing: false, error_msg: null};
  },
  componentWillMount: function () {
    let self = this;
    self.radio = {
      [self.props.radio_import_opportunities]: function (sid, opportunity_id, status, event_id) {
        self.setState({importing: true, error_msg: null});
      },
      [self.props.radio_import_opportunities_succeeded]: function (sid, opportunity_id, status, event_id) {
        if (window.location.href.includes(event_id)) {
          //we linked to existing event
          window.location.reload();
        } else {
          //we created a new event
          radio('Hashbang_set').broadcast('/events/' + event_id);
        }
      },
      [self.props.radio_import_opportunities_failed]: function (sid, opportunity_id, status, message) {
        self.setState({importing: false, error_msg: 'Failed to import from ' + self.props.service + ': ' + message});
      },
      Thirdpartyconnection_Zoho_link_opportunities_succeeded: function (sid, opportunity_id, status, event_id) {
        radio('Hashbang_set').broadcast('/events/' + event_id);
      },
      Thirdpartyconnection_Zoho_link_opportunities_failed: function (sid, opportunity_id, status, message) {
        self.setState({importing: false, error_msg: 'Failed to import from ' + self.props.service + ': ' + message});
      }
    };
  },
  __onChange: function (e) {
    this.setState({event_status: _.parseInt(e.target.value)});
  },
  __import: esUtils.wrapPreventDefault(function () {
    radio(this.props.radio_import_opportunities).broadcast(this.props.speaker_id, this.props.opportunity.Id, this.state.event_status, _.get(this.props, "link_to_event.eid", null));
  }),
  render: function () {
    let onClose = this.props.onClose;
    let opportunity = this.props.opportunity;
    let Displaylists = this.props.Displaylists;
    let event_status = this.state.event_status;
    let service_name = _.get(this.props, "service", "CRM");
    let link_to_event = _.get(this.props, "link_to_event");

    let verb = _.isEmpty(link_to_event) ? "Import" : "Link";
    service_name = service_name[0].toUpperCase() + service_name.slice(1);

    if (this.state.importing) {
      return Modal({title: verb + ' from ' + service_name + '...', buttons: []}, LoadingWrap({text: verb + 'ing...', is_loading: true}));
    }


    return Modal({
        title: verb + " " + service_name + ' opportunity',
        buttons: [],
        onClose: onClose
      },
      ErrorAlert({message: this.state.error_msg}),
      dd.div(null,
        (_.isEmpty(link_to_event)) ? dd.p(null,
          'You are about to import the ' + service_name + ' opportunity "' + _.get(opportunity, "OpportunityTitle", 'title') + '" into your eSpeakers calendar as a ',
          dd.select({value: event_status, onChange: this.__onChange},
            _.map(Displaylists && Displaylists.universal && Displaylists.universal.eventstatuses, function (a) {
              return dd.option({key: a.id, value: a.id}, a.description);
            })
          ),
          ' event.'
        ) : dd.p(null,
          "You are about to link the " + service_name + " opportunity \"" + _.get(opportunity, "OpportunityTitle", 'title') + "\" to this event."),
        dd.p(null,
          'Proceed?'
        )
      ),
      dd.div({className: 'text-center'},
        dd.button({className: 'btn btn-primary', onClick: this.__import}, verb),
        ' ',
        dd.button({className: 'btn btn-default', onClick: onClose}, 'Cancel')
      )
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/ImportEvent.js